import { BodyText, Dialog } from '@servicetitan/design-system';
import { useDependencies } from '@servicetitan/react-ioc';
import { FC } from 'react';

import { AccountSettingsStore } from '../../stores/account-settings.store';

export const ConfirmMFAEnableDialog: FC = () => {
    const [{ saveChanges, closeConfirmMFAEnableDialog }] = useDependencies(AccountSettingsStore);

    return (
        <Dialog
            open
            title="Enable Multi-Factor Authentication?"
            portal
            onPrimaryActionClick={saveChanges}
            onSecondaryActionClick={closeConfirmMFAEnableDialog}
            primaryActionName="Save and Log Out"
            secondaryActionName="Cancel"
        >
            <BodyText>Saving changes will enable MFA and log out from current session</BodyText>
        </Dialog>
    );
};
